/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */
import { Box } from "@mui/material";
import { visuallyHidden } from "@mui/utils";

export type VisuallyHiddenProps = {
  children?: string;
};

/*
 * Makes content readable for screenreads but hides them from ui see:
 * https://mui.com/system/screen-readers/ or https://v3.tailwindcss.com/docs/screen-readers
 *
 */
export default function VisuallyHidden({ children }: VisuallyHiddenProps) {
  return <Box sx={visuallyHidden}>{children}</Box>;
};
